import { fromJS, Map } from 'immutable';

import { reducerFactory } from '@Utils/Redux/reducerFactory';

export const initialState = fromJS({
  products: Map(),
});
export const reducerKey = 'RcsResults';
export const rcsResultsStoreProductsType = 'rcsResultsStoreProductsType';
export const rcsResultsSetCheckedProductForSubstanceType = 'rcsResultsSetCheckedProductForSubstanceType';
export const rcsResultsSetAllCheckedProductsForSubstanceType = 'rcsResultsSetAllCheckedProductsForSubstanceType';

export const actionsSpec = {
  [rcsResultsStoreProductsType]: (state, action) => {
    const { substanceId, products } = action.payload;
    return state.setIn(['products', substanceId], fromJS(products));
  },
  [rcsResultsSetCheckedProductForSubstanceType]: (state, action) => {
    const { substanceId, productId, checked } = action.payload;
    return state.setIn(['products', substanceId, productId, 'checked'], checked);
  },
  [rcsResultsSetAllCheckedProductsForSubstanceType]: (state, action) => {
    const { substanceId, checked } = action.payload;
    return state.updateIn(['products', substanceId], Map(), products => products.map(p => p.merge({ checked })));
  },
};

export const { reducer, actionTypes } = reducerFactory (actionsSpec, initialState);
